module.exports = __webpack_public_path__ + "img/5.7ed83708.png";